(function () {
  "use strict";

  var TAG_PREFIX = "oem|";

  function isCode(term) {
    var t = String(term || "").trim();
    if (!t || /\s/.test(t) || t.length < 5 || t.length > 40) return false;
    if (!/\d/.test(t) || !/[A-Za-z]/.test(t)) return false;
    if (/^(tag|oem):/i.test(t) || t.indexOf("|") !== -1) return false;
    return /-/.test(t) || /^[A-Za-z0-9]{8,}$/.test(t);
  }

  function candidates(term) {
    var code = String(term).trim();
    var up = code.toUpperCase();
    var list = [TAG_PREFIX + up, 'tag:"' + TAG_PREFIX + up + '"'];
    if (up !== code) list.push(TAG_PREFIX + code, 'tag:"' + TAG_PREFIX + code + '"');
    return list;
  }

  function suggestUrl(q) {
    var base = (window.routes && window.routes.predictive_search_url) || "/search/suggest";
    if (!/\.json$/.test(base)) base += ".json";
    return (
      base +
      "?q=" +
      encodeURIComponent(q) +
      "&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=tag"
    );
  }

  function hasTag(product, tag) {
    var tags = (product && product.tags) || [];
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).toLowerCase() === tag) return true;
    }
    return false;
  }

  var memo = {};

  function exactMatches(term) {
    if (!isCode(term)) return Promise.resolve(null);
    var key = String(term).trim().toLowerCase();
    if (memo[key]) return memo[key];

    var wanted = TAG_PREFIX + key;
    var lookups = candidates(term).map(function (q) {
      return fetch(suggestUrl(q), { headers: { Accept: "application/json" } })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (json) {
          var products = (json && json.resources && json.resources.results && json.resources.results.products) || [];
          var handles = [];
          products.forEach(function (p) {
            if (p && p.handle && hasTag(p, wanted)) handles.push(p.handle);
          });
          return handles.length ? { query: q, handles: handles } : null;
        })
        .catch(function () {
          return null;
        });
    });
    memo[key] = Promise.all(lookups).then(function (results) {
      for (var i = 0; i < results.length; i++) if (results[i]) return results[i];
      return null;
    });
    return memo[key];
  }

  function handleFromHref(href) {
    var m = String(href || "").match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function pruneItems(root, itemSelector, handles) {
    var keep = {};
    handles.forEach(function (h) {
      keep[h] = true;
    });
    var items = root.querySelectorAll(itemSelector);
    var kept = 0;
    items.forEach(function (li) {
      var a = li.querySelector("a[href*='/products/']");
      var h = a && handleFromHref(a.getAttribute("href"));
      if (h && keep[h]) kept++;
      else li.remove();
    });
    return kept;
  }

  function replaceCount(el, n) {
    if (!el) return;
    var text = el.textContent.replace(/\d+/, String(n));
    if (n === 1) text = text.replace(/\bresults\b/i, "result");
    el.textContent = text;
  }

  function pruneDropdown(markup, handles, term) {
    var root = document.createElement("div");
    root.innerHTML = markup;
    var kept = pruneItems(root, ".predictive-search_item[data-product-type]", handles);
    replaceCount(root.querySelector("[data-predictive-search-count]"), kept);

    var tabs = root.querySelectorAll(".predictive-search_tab[data-filter-type]");
    var remaining = 0;
    tabs.forEach(function (tab) {
      var type = tab.getAttribute("data-filter-type");
      if (type === "*") {
        replaceCount(tab.querySelector(".predictive-search_tab-count"), kept);
        return;
      }
      var n = root.querySelectorAll('.predictive-search_item[data-product-type="' + type.replace(/"/g, '\\"') + '"]').length;
      if (!n) tab.remove();
      else {
        remaining++;
        replaceCount(tab.querySelector(".predictive-search_tab-count"), n);
      }
    });
    var tabWrap = root.querySelector("[data-search-tabs]");
    if (tabWrap && remaining < 2) tabWrap.remove();

    var toggle = root.querySelector("[data-view-toggle]");
    if (toggle && !kept) toggle.remove();
    return root.innerHTML;
  }

  function displayTerm(q) {
    var s = String(q || "");
    var m = s.match(/^(?:tag:)?"?oem\|([^"]+)"?$/i);
    return m ? m[1] : s;
  }

  window.FourPhOemSearch = {
    isCode: isCode,
    exactMatches: exactMatches,
    pruneDropdown: pruneDropdown,
    displayTerm: displayTerm,
    TAG_PREFIX: TAG_PREFIX,
  };

  function boot() {
    var el = document.querySelector("[data-4ph-oem-search]");
    if (!el) return;

    var params = new URLSearchParams(window.location.search);
    var q = params.get("q") || "";
    var original = params.get("oem_code");

    if (original) {
      document.querySelectorAll('input.predictive-search_input, input[name="q"]:not([type="hidden"])').forEach(function (input) {
        if (displayTerm(input.value) !== input.value || input.value === q) input.value = original;
      });
      exactMatches(original).then(function (match) {
        if (!match) return;
        var grid = document.querySelector("#ProductGrid") || document;
        var kept = pruneItems(grid, ".collection_product", match.handles);
        replaceCount(grid.querySelector("[data-js-product-count] h2"), kept);
        var empty = grid.querySelector(".collection_empty");
        if (empty && kept) empty.remove();
      });
      return;
    }

    var terms = el.getAttribute("data-terms") || q;
    if (!isCode(terms)) return;

    exactMatches(terms).then(function (match) {
      if (!match) return;
      var next = new URLSearchParams(window.location.search);
      next.set("q", match.query);
      next.set("oem_code", terms.trim());
      if (!next.get("type")) next.set("type", "product");
      window.location.replace(window.location.pathname + "?" + next.toString());
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
